import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Button, Icon} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

class UecareFAB extends Component {

    static propTypes = {
        icon: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    };

    render() {
        const {classes, color, icon} = this.props;

        return (
            <Button
                variant="fab"
                color="primary"
                aria-label="add"
                className={classes.addButton}
                onClick={this.props.onClick}
            >
                <Icon style={{color:color}}>{icon}</Icon>
            </Button>
        );
    }
}

const styles = theme => ({
    addButton: {
        position: 'fixed',
        right: 12,
        bottom: 12,
        zIndex: 99
    }
});

export default withStyles(styles, {withTheme: true})(UecareFAB);



// WEBPACK FOOTER //
// ./src/components/UecareFAB.js